(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RfGlobalTimeFilter', [RfGlobalTimeFilterFn]);

    // time filter (hour, minute), uses moment.locale (set on login)
    function RfGlobalTimeFilterFn() {
        return function (date) {
            if (date) {
                return moment(date).format('LT');
            }
            return date;
        };
    }
})();